/**
 * Downloads data as a JSON file with a formatted filename.
 *
 * @param {Object} data - The data to be downloaded as JSON.
 * @param {Object} details - An object containing classification details.
 * @param {string} details.classification - The primary classification of the data.
 * @param {string} details.sub_classification - The sub-classification of the data.
 * @param {string} details.name - The name of the data resource.
 * @param {string} [prefix='quickgraph'] - An optional prefix for the filename (default is 'quickgraph').
 */
export const downloadJSON = (data, details, prefix = "quickgraph") => {
  const browserLocale = navigator.language || navigator.userLanguage;
  const json = JSON.stringify(data);
  const blob = new Blob([json], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;

  // Generate the formatted date string
  const formattedDate = new Date()
    .toLocaleString(browserLocale, {
      timeZone: "UTC",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .replace(/[,:\s]/g, "-");

  // Construct the filename
  link.download = `${formattedDate}_${prefix}_resource-${details.classification}_${details.sub_classification}_${details.name}.json`;

  // Trigger the download
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up the URL object
  URL.revokeObjectURL(url);
};
